import React, { memo, useCallback } from 'react';

import { useStampManagement } from 'pages/document/page/components/ApprovalStampManagement/useStampManagement';

import {
  ApprovalStampLayout,
  ApprovalStampDraggable,
} from 'pages/document/page/components/ApprovalStampManagement/StyledComponent';
import SvgIcon from '@mui/material/SvgIcon';

import { ReactComponent as StampSVG } from './stamp.svg';

import cx from 'classnames';

const ApprovalStampManagement = (props) => {
  const { setStampRef, handleMouseUp, handleMouseDown, handleMouseMove, coordinates, stampDimensions, stampMode } =
    useStampManagement(props);

  const { height: stampH, width: stampW } = stampDimensions;

  const onClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  return (
    <ApprovalStampLayout onMouseMove={handleMouseMove} onMouseLeave={handleMouseUp}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
      <ApprovalStampDraggable
        role="button"
        tabIndex={0}
        onClick={onClick}
        ref={setStampRef}
        className={cx({ [stampMode]: stampMode })}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        style={{
          transform: `translate(${coordinates.x}px, ${coordinates.y}px)`,
        }}
      >
        <SvgIcon component={StampSVG} inheritViewBox sx={{ height: stampH, width: stampW }} />
        {/* <IconApprovalStampBlank height={stampH} width={stampW} /> */}
      </ApprovalStampDraggable>
    </ApprovalStampLayout>
  );
};

export default memo(ApprovalStampManagement, (props, prevProps) =>
  // after start moving stamp we dispatch stamp mode to store and after this component rerender, but current dimensions of page are not changed
  // so, we stop excess rerender
  // I think, when react compare props {height: 10, width: 10} are not equal {height: 10, width: 10} for example
  // {} === {} -> false

  props.currentDimensions.equals(prevProps.currentDimensions),
);
